import type { ReactNode } from 'react';
import { InfoTip } from '@/components/feedback/InfoTip';

interface SectionCardProps {
  title?: ReactNode;
  subtitle?: string;
  toolbar?: ReactNode;
  /** helpTexts anahtarı — başlığın yanında ⓘ gösterir. */
  helpKey?: string;
  /** Gövdesi tabloyla dolan kartlarda iç boşluk istenmez. */
  flush?: boolean;
  className?: string;
  bodyClassName?: string;
  children: ReactNode;
}

/** Başlık + araç çubuğu + gövde taşıyan standart kart. */
export function SectionCard({
  title,
  subtitle,
  toolbar,
  helpKey,
  flush = false,
  className = '',
  bodyClassName = '',
  children,
}: SectionCardProps) {
  return (
    <div className={`card ${className}`}>
      {(title || toolbar) && (
        <div className="card-header">
          <div className="min-w-0">
            {title && (
              <h2 className="card-title">
                {title}
                {helpKey && <InfoTip helpKey={helpKey} />}
              </h2>
            )}
            {subtitle && <p className="card-subtitle">{subtitle}</p>}
          </div>
          {toolbar && <div className="d-flex align-items-center gap-2">{toolbar}</div>}
        </div>
      )}
      <div className={`card-body ${flush ? 'card-body--flush' : ''} ${bodyClassName}`}>
        {children}
      </div>
    </div>
  );
}
